
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Alert from 'vux/src/components/alert/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'


export default {
components: {
Cell,
Group,
CellBox,
Confirm,
Alert,
XButton,
Tab,
TabItem,
Swiper,
SwiperItem
},
name: 'invitation',
data() {
return {
select: '',
account: '',
orders_closed: [],
orders_unclosed: [],
payList: [],
list: ['待付费', '未完成', '已完成'],
arr: [0, 0, 0],
index: 1,
role: '',
loadmoreone: '加载更多',
loadmoretwo: '加载更多',
show: false,
hide: false,
isDisabled: false,
isid: '',
isPage: false
}
},
methods: {
showMoreorders() {
var offset
var closed
let username, role

this.isDisabled = true
if (this.index === 1) {
offset = this.orders_unclosed.length
closed = false
} else if (this.index === 0) {
offset = this.payList.length
} else {
offset = this.orders_closed.length
closed = true
}
var app = this
var token = localStorage.getItem('token')
var opid = localStorage.getItem('userid')
var obj = {
headers: {
token: token,
opid: opid
}
}

AjaxPlugin.$http.get('/api/v1/accounts/' + opid, obj)
.then((res) => {
for (let i = 0; i < res.data.length; i++) {
if (res.data[i].type === 'INDV') {
role = 'INDV'
} else if (res.data[i].type === 'ENTP') {
role = 'ENTP'
}
}

if (this.select === '待付费') {
this.$http.get('/api/v1/payments/' + opid + '/orders/user_list_repair_to_pay?role=INDV&payed=false&offset=' + offset + '&count=10', obj)
.then(response => {
this.payList = [...this.payList, ...response.data.content]
this.isPage = response.data.total !== this.payList;
})
} else {
AjaxPlugin.$http.get('/api/v1/normalrepairs?account=' + opid + '&role=' + role + '&offset=' + offset + '&count=10&closed=' + closed, obj)
.then((response) => {
app.isDisabled = false
if (app.index === 1) {
app.loadmoretwo = '加载中'
if (response.data.content.length === 10) {
app.loadmoretwo = '加载更多'
} else {
app.show = false
}
} else {
app.loadmoreone = '加载中'
if (response.data.content.length === 10) {
app.loadmoreone = '加载更多'
} else {
app.hide = false
}
}
var orders = []
orders = response.data.content
for (var i = 0; i < orders.length; i++) {
if (app.index === 1) {
switch (orders[i]['state']) {
case 'WAIT':
orders[i]['state'] = '待派单'
break
case 'PROCESS':
orders[i]['state'] = '处理中'
break
case 'FAIL':
orders[i]['state'] = '处理失败'
break
case 'SUCCESS':
orders[i]['state'] = '处理成功'
break
default:
break
}
switch (orders[i]['canstate']) {
case 'REQUEST':
orders[i]['state'] = '取消待确认'
break
}
if (orders[i]['resstate'] === 'WAIT') {
orders[i]['state'] = '待接单'
}
}
if (app.index === 2) {
switch (orders[i]['state']) {
case 'WAIT':
orders[i]['state'] = '待派单'
break
case 'PROCESS':
orders[i]['state'] = '处理中'
break
case 'FAIL':
orders[i]['state'] = '处理失败'
break
case 'SUCCESS':
orders[i]['state'] = '处理成功'
break
default:
break
}
if (orders[i]['resstate'] === 'WAIT') {
orders[i]['state'] = '待接单'
}
}
if (app.index === 1) {
app.orders_unclosed.push(orders[i])
} else {
app.orders_closed.push(orders[i])
}
}
})
.catch(function (error) {
app.isDisabled = false
if (error.response) {
console.log(error.response.data)
if (error.response.data) {
app.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
} else if (error.request) {
console.log(error.request)
} else {
console.log('Error', error.message)
}
})
}
})
}
},
created() {
var openid = localStorage.getItem('openid')
const unionid = localStorage.getItem('unionid')
var that = this
var app = this
var role
this.$http.get('api/v1/wechat/' + unionid)
.then((res) => {



if (res.data.length !== 0) {
let account = res.data[0].account
localStorage.setItem('account', account)
that.$http.post('api/v1/wechat/' + unionid + '/token', {'account': account})
.then((res) => {
localStorage.setItem('token', res.data.token)
localStorage.setItem('userid', res.data.userid)
var opid = res.data.userid
var obj = {
headers: {
token: res.data.token,
opid: res.data.userid
}
}

that.$http.get('api/v1/accounts/' + res.data.userid, obj)
.then((response) => {
for (var i = 0; i < response.data.length; i++) {

if (response.data[i].type == 'INDV' || response.data[i].type == 'ENTP') {
role = response.data[i].type
break;
}
if (response.data[i].type == 'EXPT' || response.data[i].type == 'SRVP') {
that.isid = response.data[i].type
}
}

if (role == 'INDV' || role == 'ENTP') {

AjaxPlugin.$http.get('/api/v1/normalrepairs?account=' + opid + '&role=' + role + '&offset=0&count=10&closed=true', obj)
.then((response) => {
app.orders_closed = response.data.content
app.arr[2] = response.data.total
if (response.data.total > 10) {
app.hide = true;
}
for (var i = 0; i < app.orders_closed.length; i++) {
switch (app.orders_closed[i]['state']) {
case 'WAIT':
app.orders_closed[i]['state'] = '待派单'
break
case 'PROCESS':
app.orders_closed[i]['state'] = '处理中'
break
case 'FAIL':
app.orders_closed[i]['state'] = '处理失败'
break
case 'SUCCESS':
app.orders_closed[i]['state'] = '处理成功'
break
default:
break
}
if (app.orders_closed[i]['resstate'] === 'WAIT') {
app.orders_closed[i]['state'] = '待接单'
}
}
})

AjaxPlugin.$http.get('/api/v1/normalrepairs?account=' + opid + '&role=' + role + '&offset=0&count=10&closed=false', obj)
.then(function (response) {
app.orders_unclosed = response.data.content
app.arr[1] = response.data.total
if (response.data.total > 10) {
app.show = true;
}
for (var i = 0; i < app.orders_unclosed.length; i++) {
switch (app.orders_unclosed[i]['state']) {
case 'WAIT':
app.orders_unclosed[i]['state'] = '待派单'
break
case 'PROCESS':
app.orders_unclosed[i]['state'] = '处理中'
break
case 'FAIL':
app.orders_unclosed[i]['state'] = '处理失败'
break
case 'SUCCESS':
app.orders_unclosed[i]['state'] = '处理成功'
break
default:
break
}
if (app.orders_unclosed[i]['resstate'] === 'WAIT') {
app.orders_unclosed[i]['state'] = '待接单'
}
switch (app.orders_unclosed[i]['canstate']) {
case 'REQUEST':
app.orders_unclosed[i]['state'] = '取消待确认'
break
}
}
})
AjaxPlugin.$http.get('/api/v1/payments/' + opid + '/orders/user_list_repair_to_pay?role=INDV&payed=false&offset=0&count=10', obj)
.then(response => {
this.payList = response.data.content
app.arr[0] = response.data.total
if (response.data.total > 10) {
this.isPage = true
}
})
} else {
var iden
if (that.isid == 'EXPT') {
iden = '个人用户'
}
if (that.isid == 'SRVP') {
iden = '企业用户'
}
that.$vux.confirm.show({
title: '',
content: '您的身份不符合该功能,如需用该功能,请添加' + iden,
onConfirm() {
that.$router.push({name: 'addmyInfo'})
},
onCancel() {
WeixinJSBridge.call('closeWindow');
}
})
}
})
.catch(function (error) {
if (error.response) {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
}
})
})
.catch(function (error) {
if (error.response) {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
}
})
} else {
localStorage.setItem('repair', 'normalrepairslist')
that.$router.push({name: 'login'})
}
})
.catch(function (error) {
console.log(error.response)
if (error.response) {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
}
})
},
beforeRouteLeave(to, from, next) {
if (to.name == 'normalcomplete') {
next()
} else {
localStorage.removeItem('order')
}
localStorage.removeItem('list')
next()
}
}



// WEBPACK FOOTER //
// ./src/components/normalrepairslist.vue